/* eslint-disable max-len */

import React from 'react';

export const SparklesOutlineIcon = () => {
  return (
    <svg
      className="stroke-icon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 1.33337L9 4.33337L12 5.33337L9 6.33337L8 9.33337L7 6.33337L4 5.33337L7 4.33337L8 1.33337Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33333 9.33337L3.83333 10.8334L5.33333 11.3334L3.83333 11.8334L3.33333 13.3334L2.83333 11.8334L1.33333 11.3334L2.83333 10.8334L3.33333 9.33337Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 9.33337L12.5 10.8334L14 11.3334L12.5 11.8334L12 13.3334L11.5 11.8334L10 11.3334L11.5 10.8334L12 9.33337Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
